import React from 'react';
import ReactShow from 'react-show';

import './accordion.css';

class Section extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        if (this.state.open) {
            if (this.props.selected === this.props.idx) {
                this.setState({ open: false });
            }
        } else {
            this.setState({ open: true });
        }
        this.props.updateSelected();
    }

    render() {
        const { idx, children, selected, value } = this.props;
        const expanded = (this.state.open && (selected === idx));
        return (
            <div className='section'>
                <div className='section-header' onClick={this.handleClick}>
                    {value}
                    <div><i className={`accordion-arrow ${expanded ? 'fa fa-angle-up' : 'fa fa-angle-down'}`}/></div>
                </div>
                <ReactShow show={expanded} className='open-wrap'>
                    {children}
                </ReactShow>
            </div>
        );
    }
}

class SectionContent extends React.Component {

    render() {
        const { content } = this.props;
        return (
            <div className='section-content'>
                {content
                    .map((item, idx) => (<div key={idx} className='content-item'>{item}</div>))
                }
            </div>
        );
    }
}

class Accordion extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: -1,
        };
    }

    render() {
        const { sections = [] } = this.props;
        return (
            <div>
                {
                    sections.map((s, idx) =>
                        <Section
                            key={idx}
                            open={this.state.open}
                            updateSelected={() => this.setState({ selected: idx })}
                            idx={idx}
                            selected={this.state.selected}
                            value={s.value}
                            {...this.props}
                        >
                            <SectionContent content={s.items}/>
                        </Section>)
                }
            </div>
        );
    }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js